import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2e709153 = () => interopDefault(import('..\\pages\\about\\index.vue' /* webpackChunkName: "pages/about/index" */))
const _b2dcbce8 = () => interopDefault(import('..\\pages\\download\\index.vue' /* webpackChunkName: "pages/download/index" */))
const _418b0233 = () => interopDefault(import('..\\pages\\help\\index.vue' /* webpackChunkName: "pages/help/index" */))
const _a3d46456 = () => interopDefault(import('..\\pages\\home\\index.vue' /* webpackChunkName: "pages/home/index" */))
const _9934913e = () => interopDefault(import('..\\pages\\news\\index.vue' /* webpackChunkName: "pages/news/index" */))
const _3673c3bc = () => interopDefault(import('..\\pages\\notice\\index.vue' /* webpackChunkName: "pages/notice/index" */))
const _79e32feb = () => interopDefault(import('..\\pages\\noticesys\\index.vue' /* webpackChunkName: "pages/noticesys/index" */))
const _38f81c91 = () => interopDefault(import('..\\pages\\serve\\index.vue' /* webpackChunkName: "pages/serve/index" */))
const _62791a66 = () => interopDefault(import('..\\pages\\noticesys\\detail-sd.vue' /* webpackChunkName: "pages/noticesys/detail-sd" */))
const _195f505c = () => interopDefault(import('..\\pages\\wechat\\download.vue' /* webpackChunkName: "pages/wechat/download" */))
const _cad6ba12 = () => interopDefault(import('..\\pages\\news\\_guid.vue' /* webpackChunkName: "pages/news/_guid" */))
const _1da2af52 = () => interopDefault(import('..\\pages\\notice\\_guid.vue' /* webpackChunkName: "pages/notice/_guid" */))
const _61121b81 = () => interopDefault(import('..\\pages\\noticesys\\_guid.vue' /* webpackChunkName: "pages/noticesys/_guid" */))
const _ddc211d8 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _2e709153,
    alias: "/about/index.html",
    name: "about"
  }, {
    path: "/download",
    component: _b2dcbce8,
    alias: "/download/index.html",
    name: "download"
  }, {
    path: "/help",
    component: _418b0233,
    alias: "/help/index.html",
    name: "help"
  }, {
    path: "/home",
    component: _a3d46456,
    alias: "/home/index.html",
    name: "home"
  }, {
    path: "/news",
    component: _9934913e,
    alias: "/news/index.html",
    name: "news"
  }, {
    path: "/notice",
    component: _3673c3bc,
    alias: "/notice/index.html",
    name: "notice"
  }, {
    path: "/noticesys",
    component: _79e32feb,
    alias: "/noticesys/index.html",
    name: "noticesys"
  }, {
    path: "/serve",
    component: _38f81c91,
    alias: "/serve/index.html",
    name: "serve"
  }, {
    path: "/noticesys/detail-sd",
    component: _62791a66,
    alias: "/noticesys/detail-sd/index.html",
    name: "noticesys-detail-sd"
  }, {
    path: "/wechat/download",
    component: _195f505c,
    alias: "/wechat/download/index.html",
    name: "wechat-download"
  }, {
    path: "/news/:guid",
    component: _cad6ba12,
    alias: "/news/:guid/index.html",
    name: "news-guid"
  }, {
    path: "/notice/:guid",
    component: _1da2af52,
    alias: "/notice/:guid/index.html",
    name: "notice-guid"
  }, {
    path: "/noticesys/:guid",
    component: _61121b81,
    alias: "/noticesys/:guid/index.html",
    name: "noticesys-guid"
  }, {
    path: "/",
    component: _ddc211d8,
    alias: "/index.html",
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
